import moment from "moment";

const defaultShortDateFormat = "MMM Do[,] YYYY"

const toShortDate = (date = new Date()) => {
    const momentDate = moment(date).format(defaultShortDateFormat);
    return momentDate;
}

export default toShortDate;